/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import { PencilIcon } from '@heroicons/react/24/outline'

interface InfoCardProps {
    title: string
    children: React.ReactNode
}

export const InfoCard: React.FC<InfoCardProps> = ({ title, children }) => {
    return (
        <div className="UiCard p-2 flex flex-col">
            <h3 className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2 pb-1 border-b border-gray-200 dark:border-gray-700">
                {title}
            </h3>
            <div className="flex flex-col gap-1.5 text-xs">{children}</div>
        </div>
    )
}

interface InfoRowProps {
    label: React.ReactNode
    value: React.ReactNode
    onEdit?: () => void
}

export const InfoRow: React.FC<InfoRowProps> = ({ label, value, onEdit }) => {
    return (
        <div className="flex justify-between items-center gap-2 min-h-6">
            <span className="text-gray-600 dark:text-gray-400 shrink-0">
                {label}
            </span>
            <div className="flex items-center gap-2 justify-end">
                <span className="text-gray-900 dark:text-gray-100 font-medium text-right">
                    {value}
                </span>
                {onEdit && (
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation()
                            onEdit()
                        }}
                        className="p-1 bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 rounded transition-colors shrink-0"
                    >
                        <PencilIcon className="w-3 h-3 text-white" />
                    </button>
                )}
            </div>
        </div>
    )
}
